/* eslint-disable tailwindcss/no-custom-classname */
import { FC, useEffect, useState } from "react";
import { UIProduct } from "../../../../components/commercetools-ui/products/product-details";

interface ProductReviewSummaryProps {
    powerReviewsPageId: string;
    product: UIProduct;
}

export const ProductReviewSummary: FC<ProductReviewSummaryProps> = ({
    powerReviewsPageId,
    product,
}) => {
    const [isWriteReview, setIsWriteReview] = useState(false);

    useEffect(() => {
        const productVariants = product.variants.map((variant) => ({
            name: product?.name,
            image_url: variant?.images[0],
            upc: "",
            page_id_variant: variant?.sku,
            manufacturer_id: "",
            description: product?.description,
        }));

        window["pwr_product_data"] = {
            page_id: powerReviewsPageId,
            product: {
                name: product?.name,
                url: window?.location?.href,
                image_url: product?.variants[0]?.images[0],
                description: product?.description,
                category_name: product?.categories[0]?.name,
                brand_name: "Christie Cookies",
                price: product?.variants[0]?.price?.centAmount / 100,
                in_stock: "1",
                variants: productVariants,
            },
            subject: {
                "@context": "https://schema.org",
                "@type": "Product",
                name: product?.name,
                description: product?.description,
                url: window?.location?.href,
                image: product?.variants[0]?.images[0],
                sku: product?.variants[0]?.sku,
                brand: "",
                category: product?.categories[0]?.name,
                weight: "",
                offers: {
                    "@type": "Offer",
                    priceCurrency: "USD",
                    url: window?.location?.href,
                    price: product?.variants[0]?.price?.centAmount / 100,
                    priceValidUntil: "",
                    availability: "https://schema.org/InStock",
                },
            },
        };
    }, [product, powerReviewsPageId]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get("pr_page_id")) {
            setIsWriteReview(true);
        }

        const script = document.createElement("script");
        script.src = "https://ui.powerreviews.com/stable/4.1/ui.js";
        script.async = true;

        script.onload = () => {
            window.pwr =
                window.pwr ||
                function () {
                    (window.pwr.q = window.pwr.q || []).push(arguments);
                };

            if (urlParams.get("pr_page_id")) {
                // WRITE REVIEW MODE
                window.pwr("render", {
                    api_key: process.env.NEXT_PUBLIC_POWER_REVIEW_API_KEY,
                    locale: "en_US",
                    merchant_group_id:
                        process.env.NEXT_PUBLIC_POWER_REVIEW_MERCHANT_GROUP_ID,
                    merchant_id:
                        process.env.NEXT_PUBLIC_POWER_REVIEW_MERCHANT_ID,

                    on_submit: function () {
                        window.scrollTo(0, 0);
                    },

                    components: {
                        Write: "pr-write",
                    },
                });
            } else {
                // NORMAL PDP REVIEWS
                window.pwr("render", {
                    api_key: process.env.NEXT_PUBLIC_POWER_REVIEW_API_KEY,
                    locale: "en_US",
                    merchant_group_id:
                        process.env.NEXT_PUBLIC_POWER_REVIEW_MERCHANT_GROUP_ID,
                    merchant_id:
                        process.env.NEXT_PUBLIC_POWER_REVIEW_MERCHANT_ID,
                    page_id: powerReviewsPageId,

                    // keep this (needed for PR flow)
                    review_wrapper_url:
                        window.location.origin + window.location.pathname + "?",

                    components: {
                        ReviewSnippet: "pr-review-snippet",
                        ReviewDisplay: "pr-review-display",
                    },
                });

                // FORCE "Write a Review" → open in new tab (guaranteed)
                setTimeout(() => {
                    const elements = document.querySelectorAll("*");

                    elements.forEach((el: any) => {
                        if (
                            el.innerText &&
                            el.innerText.trim().toLowerCase() === "write a review"
                        ) {
                            el.style.cursor = "pointer";

                            el.onclick = (e: any) => {
                                e.preventDefault();
                                e.stopPropagation();

                                const url =
                                    window.location.origin +
                                    window.location.pathname +
                                    "?pr_page_id=" +
                                    powerReviewsPageId;

                                window.open(url, "_blank");
                            };
                        }
                    });
                }, 1500);
            }
        };

        document.body.appendChild(script);
    }, [product, powerReviewsPageId]);

    if (isWriteReview) {
        return <div id="pr-write"></div>;
    }

    return (
        <>
            <div id="pr-review-snippet"></div>
        </>
    );
};
